import React, { useState, useEffect } from "react";
import { Paper, Typography, Stack, Button, Box, ButtonGroup, Divider } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ProgressGraph from "../components/Charts/ProgressGraph";

export default function VoortgangPage() {
    const navigate = useNavigate();
    const selectedProject = useSelector((state) => state.projects.selectedProject);

    if (!selectedProject) {
        return (
            <Box sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Geen project geselecteerd
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Selecteer eerst een project om de voortgang te bekijken.
                </Typography>
                <Button 
                    variant="contained" 
                    onClick={() => navigate("/")}
                    sx={{ mt: 2 }}
                >
                    Terug naar overzicht
                </Button>
            </Box>
        );
    }

    return (
        <Stack spacing={3}>
            {selectedProject.phases && selectedProject.phases.length > 0 ? (
                <ProgressGraph project={selectedProject} />
            ) : (
                <Box>
                    <Typography variant="body1" color="text.secondary">
                        Er zijn nog geen ontwerpfases voor dit project. Start het ontwerpproces om de voortgang te kunnen bekijken.
                    </Typography>
                </Box>
            )}
        </Stack>
    );
}

